import React, { useState } from 'react';
import { Tooltip } from '@material-ui/core';
import EmojiPicker from '@icarius-common/emojiPicker';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import { getLocalizedString } from '@icarius-localization/strings';

const EmojiEditor = ({ handleChange }) => {

    const [anchorEl, setAnchorEl] = useState(null);

    return (
        <button
            style={{
                width: 36,
                height: 34,
                background: "transparent",
                border: 0,
                outline: 0,
            }}
        >
            <Tooltip title={getLocalizedString("openEmojiSelector")}>
                <InsertEmoticonIcon
                    style={{ cursor: 'pointer', fill: "var(--mainText)" }}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                />
            </Tooltip>
            <EmojiPicker
                anchorEl={anchorEl}
                handleChange={handleChange}
                handleClose={() => setAnchorEl(null)}
            />
        </button>
    );
}

export default EmojiEditor;